// Africa's Talking Configuration
// Note: In production, these should be in environment variables and called via a backend server

export const AFRICASTALKING_CONFIG = {
  username: 'sandbox', // Change to your live app name when going live
  apiKey: 'atsk_9db12a507d9e0feeed1a03d41d3b0900232bff88f6c9cd89c02989abfb3aeb938341e552',
  // For sandbox testing, SMS will appear in the simulator, not real phones
  // When going live, change username to your live app name
};

// SMS Sending function - this needs a backend server for security
// We'll create a simple cloud function approach

export const generateOTP = () => {
  // Generate 6-digit OTP
  return Math.floor(100000 + Math.random() * 900000).toString();
};

export const formatPhoneNumber = (phone) => {
  // Ensure phone is in international format +254...
  let formatted = phone.replace(/\s/g, '').replace(/-/g, '');
  
  if (formatted.startsWith('0')) {
    formatted = '+254' + formatted.substring(1);
  } else if (formatted.startsWith('254')) {
    formatted = '+' + formatted;
  } else if (!formatted.startsWith('+')) {
    formatted = '+254' + formatted;
  }
  
  return formatted;
};
